import * as React from "react";

function SvgCircleClose(props) {
  return <svg height="1em" viewBox="0 0 28 28" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={14} cy={14} opacity={0.08} r={14} /><rect height={12.992} rx={0.684} transform="rotate(-45 16.924 -5.61)" width={1.368} /><rect height={12.992} rx={0.684} transform="rotate(45 -2.24 26.54)" width={1.368} /></svg>;
}

export default SvgCircleClose;